import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";

import { Language, MotesPaths } from '../models';

@Injectable({ providedIn: 'root' })
export class DeviceService {
    public readonly enableStatsDebug: boolean = false;
    private isDevServer: boolean = false;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        this.initIsDevServer();
    }

    public isIos(): boolean {
        // console.log("Is ios... userAgent: " + navigator.userAgent);
        if(typeof window == 'undefined') return false;
        return /macintosh|ipad|iphone|ipod/.test(navigator.userAgent.toLowerCase()) && navigator.maxTouchPoints > 0;
    }

    public isAndroid(): boolean {
        if(typeof window == 'undefined') return false;
        return /android/.test(navigator.userAgent.toLowerCase());
    }

    public isSafari(): boolean {
        // Obs: This does not include facebook "Safari" webview
        if(typeof window == 'undefined') return false;
        // return /^((?!chrome|android).)*(safari|applewebkit)/i.test(navigator.userAgent.toLowerCase()) || this.isIos();
        return /^(?!chrome|android).*applewebkit.*version\/.*safari/i.test(navigator.userAgent.toLowerCase()) || this.isIos();
    }

    public isMobile(): boolean {
        if(typeof window == 'undefined') return false;
        return /webos|blackberry|iemobile|opera mini|mobile|crios/.test(navigator.userAgent.toLowerCase()) || this.isIos() || this.isAndroid();
    }

    public isFacebookApp(): boolean {
        if(typeof window == 'undefined') return false;
        var agent = (navigator.userAgent || navigator.vendor || "empty").toLowerCase();
        return agent.indexOf("fban") > -1 || agent.indexOf("fbav") > -1 || agent.indexOf("instagram") > -1
    }

    public isFacebookIos(): boolean {
        // Test if it is facebook browser on ios (embedded Safari browser aka not Safari)
        return this.isIos() && this.isFacebookApp();
    }

    public isPlatformServer(): boolean {
        return isPlatformServer(this.platformId);
    }

    public isTouchDevice(): boolean {
        if(typeof window == 'undefined') return false;
        return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
    }

    public getBrowserLanguage(): Language {
        if(typeof navigator == 'undefined') return Language.en;

        // Get language string from browser (ie. 'en', 'en-US' or 'da-DK')
        let localStr = (navigator && navigator.language) ? navigator.language : 'en';

        let local = localStr.split('-');
        let language = local[0].toLowerCase();

        // Convert language str to language enum
        switch(language) {
            case 'en': return Language.en;
            case 'da': return Language.da;
            case 'sv': return Language.sv;
            default: return Language.en;
        }
    }

    private initIsDevServer() {
        // Determine if deploy is running on development server
        if(typeof window == 'undefined') return false;
        let url = location?.origin || "";
        this.isDevServer = MotesPaths.MOTES_DEV_SERVERS.findIndex(devServer => url.startsWith(devServer)) > 0;
        if(this.isDevServer) console.log("Dev server detected (disable stats)");
    }

    /**
     * Determinate if deploy is running on a develop server (and thous should disable stats
     * and other data generated from dev/test environment)
     * @returns boolean indicating if the deploy is running on a dev server
     */
    public isDevServerDeploy(): boolean {
        return this.isDevServer;
    }
}
